////////LIBRARY/////////
import React from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import Loader from 'react-loader-spinner'

/////////STYLED/////////
const LoadingInLineWrapper = styled.div`
	display: grid;
	grid-template-columns: max-content max-content;
	grid-column-gap: 10px;
	justify-content: center;
`
const TitleLoading = styled.div`
	margin-top: 5px;
	font-weight: bold;
`
/////////STYLED/////////

const LoadingInLine = ({ isLoading, translations }) => {
	///////////////////////////////// RENDER ///////////////////////////////////////

	return (
		<LoadingInLineWrapper>
			{isLoading && (
				<>
					<TitleLoading>{translations['common__text__loading']}</TitleLoading>
					<Loader type="Oval" color="#0885D5" height={25} width={25} />
				</>
			)}
		</LoadingInLineWrapper>
	)
}

LoadingInLine.propTypes = {
	isLoading: PropTypes.bool.isRequired,
}

LoadingInLine.defaultPropTypes = {
	isLoading: false,
}

export default LoadingInLine
